import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { arrays, tenants, leases } from './entities'

let group = (entity, prop) => createSelector(arrays[entity], R.groupBy(R.prop(prop)))

let index = R.mapObjIndexed(
	(entity, indices) => (
		R.mapObjIndexed(
			(_, prop) => group(entity, prop)
		  , indices
		)
	)
  , {
		application: {
			propertyAlias: 1
		}
	  , comment: {
			objectID: 1
	  	}
	  , lease: {
	  		propertyID: 1
		}
	  , listing: {
	  		propertyID: 1
		}
	  , project: {
	  		propertyID: 1
		}
	  , task: {
	  		projectID: 1
		}
	  , term: {
	  		parentID: 1
		}
	  , transaction: {
	  		partyID: 1
	  	  , propertyID: 1
		}
	}
)

export default index

export let applicationsByPropertyAlias = group('application', 'propertyAlias')
export let commentsByObjectID          = group('comment', 'objectID')
export let listingsByPropertyID        = group('listing', 'propertyID')
export let projectsByPropertyID        = group('project', 'propertyID')
export let tasksByProjectID            = group('task', 'projectID')
export let termsByLeaseID              = group('lease', 'parentID')
export let transactionsByPartyID       = group('transaction', 'partyID')
export let transactionsByPropertyID    = group('transaction', 'propertyID')

// TODO: always fill parentID on a tenant to simplify a lot of tiny bits
export let tenantsByHouseholdID = createSelector(
	arrays['tenant']
  , R.groupBy(tenant => tenant.parentID || tenant._id)
  , 'tenantsByHouseholdID'
)

// TODO: always put a transaction on a household head to simplify a lot of not-so-tiny bits
export let transactionsByHouseholdID = createSelector(
	[tenantsByHouseholdID, transactionsByPartyID]
  , (tenantsByHouseholdID, transactionsByPartyID) => {
  		return R.map(tenants => {
			let transactions = R.chain(
				tenant => {
					return transactionsByPartyID[tenant._id] || []
				}
			  , tenants
			)
			return R.sortBy(x => x.date, transactions)
  		})(tenantsByHouseholdID)
  	}
  , 'transactionsByHouseholdID'
)

export let transactionsByTenantID = createSelector(
	[tenants, transactionsByHouseholdID]
  , (tenants, transactionsByHouseholdID) => {
  		return R.map(tenant => {
	  		let householdID = tenant.parentID || tenant._id
			return transactionsByHouseholdID[householdID]
  		})(tenants)
  	}
  , 'transactionsByTenantID'
)

export let leasesByPropertyID = createSelector(
	[arrays['leaseOnly']]
  , R.groupBy(R.prop('propertyID'))
)

export let repairsByPropertyID = createSelector(
	[projectsByPropertyID, tasksByProjectID],
	(projectsByPropertyID, tasksByProjectID) => {
		let repairs = R.chain(project => {
			let tasks = tasksByProjectID[project._id] || []
			tasks = tasks.filter(x => x.taskType == "Repair")
			return tasks.map(x => ({
				...x
			  , projectName: project.title
			  , date: x.date || project.date
			}))
		})
		return R.map(repairs, projectsByPropertyID)
	}
  , 'repairsByPropertyID'
)



// WEBPACK FOOTER //
// ./src/selectors/index.js